import { useQuery } from "@tanstack/react-query";
import { getLL55Compliance } from "../sevices/ll55Api";

export function useLL55Compliance(keys, clientId) {
  const { isLoading, data, error, isError, refetch, isRefetching } = useQuery({
    queryKey: clientId ? ["ll55-compliance", clientId] : ["ll55-compliance"],
    queryFn: () => getLL55Compliance(keys),
  });

  const responseData =
    data?.data?.data?.response_data?.map((el, idx) => {
      return {
        ...el,
        id: idx + 1,
      };
    }) || [];
  const totalRecords = data?.data?.data?.total_records;

  const statusCount = data?.data?.data?.status_counts;

  return {
    isLoading,
    error,
    responseData,
    isError,
    refetch,
    totalRecords,
    statusCount,
    isRefetching,
  };
}